import script from "./SubscriptionTiers.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionTiers.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionTiers.vue?vue&type=style&index=0&id=c1a7cedc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1a7cedc"]])

export default __exports__